/**
 * FinishType identifies the nature of the 'funnel completion'.
 * External referrals are cases where the user's useragent is
 * directed to an issuers's site; this can be either an application
 * (i.e. entry into a flow to create an account, policy, etc) or
 * some other page, such as a product definition.
 * A prequal inputflow is when the terminal action is when a user "applies"
 * for a financial product at NerdWallet (starting and
 * progressing through an application is an input_flow, and
 * we'd recommend subclassing product_shopping_finish to include
 * the input_flow_id when this happens).  An internal referral
 * is for cases where we direct folks to a NerdWallet placement that
 * is not an "application".
 * @enum {string} FinishType -
 * @see @link https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/shopping_finished.yaml#L57
 *
 */
export default {
  EXTERNAL_APPLICATION: 'external_application',
  EXTERNAL_CONTENT: 'external_content',
  INTERNAL_CONTENT: 'internal_content',
  LEAD_INPUTFLOW: 'lead_inputflow',
  CLAIM_PREQUAL_OFFER: 'claim_prequal_offer',
  UNKNOWN_BUG: 'unknown_bug' // the default since it identifies that one of the above did not happen or wasn't set

};